<template>
  <a-layout class="full-height">
    <a-layout-sider theme="light" :width="220" v-model="collapsed" collapsible @collapse="isCollapse(collapsed)" :style="{ overflow: 'auto', left: 0 }">
      <a-menu
        :selectable="false"
        :selectedKeys="[selectedId]"
        mode="inline"
        :inlineIndent="16"
        :inlineCollapsed="collapsed"
        class="a-menu"
        :class="{ 'a-menu-hidden': collapsed === true }"
        :openKeys.sync="openKeys"
      >
        <template v-for="item in asideList">
          <a-menu-item v-if="item.children.length === 0" :key="item.menuKey" @click="selectSideMenu(item)">
            <a-icon type="database" />
            <span>{{ item.name }}</span>
          </a-menu-item>
          <!-- subMenu router.push在里面 -->
          <sub-menu v-else :menu-info="item" :key="item.menuKey" />
        </template>
      </a-menu>
    </a-layout-sider>
    <a-layout-content class="m-md p-m" systemSetting-content>
      <router-view></router-view>
    </a-layout-content>
  </a-layout>
</template>
<script>
import { SYSTEM_SETTING_ASIDELIST } from '@/const/common.js';
import { queryFundList } from '@/api/finance';
import { mapGetters } from 'vuex';
import Event from '@/utils/event';
import SubMenu from './SubMenu';
export default {
  components: {
    SubMenu
  },
  name: 'finance',
  data() {
    return {
      SYSTEM_SETTING_ASIDELIST, // 静态的
      asideList: [], // 动态的
      menuOpenKey: [],
      current: [],
      collapsed: false,
      openKeys: []
    };
  },
  computed: {
    ...mapGetters(['userInfo']),
    selectedId() {
      return this.$store.state.finance.menuId;
    }
  },
  watch: {
    '$route.path': function(val, oldVal) {
      if (val === '/finance') {
        this.initTable();
      }
    }
  },
  methods: {
    selectSideMenu(menu) {
      this.$store.commit('finance/setMenuId', menu.menuKey);
      this.$router.push(menu.fullPath);
    },
    collapseMenu() {
      this.collapsed = !this.collapsed;
      Event.$emit('visionRefresh');
    },
    isCollapse(a) {
      if (a === true) {
        this.openKeys = [];
      } else {
        this.initTable();
      }
    },
    /**
     * 基金数据结构：name,currency,children,fundId,fundName,fundType,canModify,munuType
     * 公允价值表数据结构：id,name,isReleased,fundId,fundName,isLeaf,canModify,tableCurrency,menuType
     */
    async initAsideList() {
      let funds = [];
      try {
        funds = await queryFundList();
        funds = funds.data || [];
      } catch (error) {
        // TODO
      }
      // 初始化左侧导航
      this.asideList = [];
      const { permissions } = this.userInfo || {};
      const currentPermission = permissions.filter(item => {
        if (this.$route.path.includes(item.fullPath) && item.fullPath !== '/') {
          // 首页为'/'
          return item;
        }
      });
      if (currentPermission) {
        const { children } = currentPermission[0];
        if (children) {
          //循环菜单
          children.forEach(menu => {
            let list = [];
            const idMap = {
              人民币主基金: 0,
              人民币专项基金: 1,
              人民币Feeder基金: 3,
              美元主基金: 10,
              美元专项基金: 11,
              美元Feeder基金: 13,
              人民币投资基金: 7
            };
            menu.children && (list = menu.children.filter(menu => menu.type === 0));
            list.forEach(item => {
              //循环基金 item是基金
              item.children = funds
                .filter(fund => {
                  return fund.fundType === idMap[item.name];
                })
                .map(item => {
                  item.fundId = item.id;
                  item.canModify = item.canModify;
                  item.allowSwitch = item.allowSwitch;
                  item.menuType = 'fund';
                  if (item.fair && item.fair.length > 0) {
                    //_item是表
                    item.children = item.fair.map(_item => {
                      _item.fundName = item.name;
                      _item.fundId = item.id;
                      _item.fundType = item.fundType;
                      _item.fairId = _item.id;
                      _item.isLeaf = true;
                      _item.canModify = item.canModify;
                      _item.allowSwitch = item.allowSwitch;
                      //_item.ifRelease
                      _item.tableCurrency = item.currency;
                      _item.menuType = 'fairTable';
                      _item.menuKey = `fairMenu_${_item.id}`;
                      return _item;
                    });
                  }
                  item.fundName = item.name;
                  item.name = item.shortName;
                  item.menuKey = `fundMenu_${item.id}`;
                  delete item.fair;
                  delete item.id;
                  return item;
                });

              if (item.children.length === 0) {
                delete item.children;
              }
              item.menuKey = `subMenu_${item.id}`;
              item.menuType = idMap[item.name] !== undefined ? 'fundType' : 'normal';
            });
            const asideItem = {
              name: menu.name,
              icon: menu.icon,
              children: list,
              menuKey: `menu${menu.id}`,
              fullPath: menu.fullPath
            };
            this.asideList.push(asideItem);
          });
        }
      }
    },
    initTable() {
      let { path } = this.$route;
      let { asideList } = this;
      let menu;
      let openKeys;
      let defaultOpenFlag = false;
      let tableList = asideList.find(e => e.name === '公允价值表');
      // 需要拿到fundId的情况
      // 菜单权限有公允价值表,且目前路由是fmv报表页
      if ((tableList && path === '/finance/fairvalueTable') || path.indexOf('RMB') > -1 || path.indexOf('USD') > -1) {
        let { fundId, fairId } = this.$route.query;
        if (!fundId) {
          this.openKeys = [tableList.menuKey];
          return;
        }
        tableList.children.forEach(typeFund => {
          if (typeFund.children && typeFund.children.length) {
            typeFund.children.forEach(fund => {
              if (+fund.fundId === +fundId) {
                let fair = (fund.children || []).find(_ => +_.fairId === +fairId);
                if (fair) {
                  menu = fair;
                  openKeys = [tableList.menuKey, typeFund.menuKey, fund.menuKey, fair.menuKey];
                } else {
                  menu = (fund.children && fund.children[0]) || fund;
                  openKeys = [tableList.menuKey, typeFund.menuKey, fund.menuKey];
                }
              }
            });
          }
        });
        menu = (menu && menu.children && menu.children[0]) || menu;
        Event.$emit('switchSideMenu', menu);
      } else {
        // 菜单列表切换openKey
        // 除了fmv以外所有页面
        asideList.forEach(_ =>
          _.children.forEach(sub => {
            if (sub.fullPath === path) {
              menu = sub;
              openKeys = [_.menuKey];
            }
          })
        );
      }
      this.openKeys = openKeys || [asideList[0].menuKey];
      this.$store.commit('finance/setMenuId', (menu && menu.menuKey) || asideList[0].menuKey);
      // 点击北冥后后默认选中项目交易数据
      if (path === '/finance') {
        this.$router.push(asideList[0].fullPath ? asideList[0].fullPath : '/finance');
      }
    }
  },
  async mounted() {
    await this.initAsideList();
    this.initTable();
    Event.$on('refresh-fund', async () => {
      await this.initAsideList();
      this.initTable();
    });
    Event.$on('setPermission', this.initAsideList);
  },
  beforeDestroy() {
    Event.$off('setPermission', this.initAsideList);
  }
};
</script>

<style lang="less" scoped>
& /deep/ .ant-layout-sider-has-trigger .ant-layout-sider-children {
  height: calc(100vh - 94px); // 侧边栏固定高度,header46px,trigger48px
  position: fixed;
  overflow: auto;
}
& /deep/ .ant-layout-sider-trigger {
  border: 1px solid #e8e8e8;
}
.a-menu {
  width: 220px;
  min-height: 100%; // 右描边
}
.a-menu-hidden {
  width: 80px;
}
.full-height {
  user-select: none;
  .collapse-btn-container {
    display: flex;
    .trigger {
      margin: 0 40px 30px 0px;
      cursor: pointer;
    }
    .hint {
      font-size: 16px;
      margin-left: -10px;
    }
  }
}
[systemSetting-content] {
  background: #fff;
}

// 滚动条样式
// 目前是隐藏的,把width调20就有滚动条了
& /deep/ .ant-layout-sider-children::-webkit-scrollbar {
  width: 20px;
}

& /deep/ .ant-layout-sider-children::-webkit-scrollbar-thumb {
  border-radius: 12px;
  border: 6px solid rgba(0, 0, 0, 0);
  box-shadow: 8px 0 0 rgba(0, 0, 0, 0.1) inset;
}
</style>
